import React, { Component } from 'react';

import SiteContainer from './home';

class App extends Component {
  
  render() {
    return (
      <div className="App">
        <SiteContainer  />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js